import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createStoreApi } from "../../services/store/create.store.api";
import { createMachineApi } from "../../services/machine/create.machine.api";

export const useCreateMachineApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoCreate: any) => createMachineApi(infoCreate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-machine-of-store"],
      });
    },
  });
};
